package dev.youndie.site.components.sections

import androidx.compose.runtime.Composable
import dev.youndie.site.model.EMAIL
import dev.youndie.site.model.GITHUB
import org.jetbrains.compose.web.attributes.ATarget
import org.jetbrains.compose.web.attributes.target
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Footer
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun SiteFooter() {
    Footer(attrs = { classes("site-footer") }) {
        Div(attrs = { classes("footer-inner") }) {
            // Both names link out. Crediting two technologies and making only one of them
            // reachable reads as an oversight rather than a choice.
            Span {
                Text("built with ")
                A(href = "https://kotlinlang.org", attrs = {
                    target(ATarget.Blank)
                    attr("rel", "noopener")
                }) { Text("kotlin") }
                Text(" + ")
                A(href = "https://kobweb.varabyte.com/", attrs = {
                    target(ATarget.Blank)
                    attr("rel", "noopener")
                }) { Text("kobweb") }
            }
            Div(attrs = { classes("footer-links") }) {
                A(href = GITHUB, attrs = {
                    target(ATarget.Blank)
                    attr("rel", "noopener")
                }) { Text("github") }
                A(href = "mailto:$EMAIL") { Text("email") }
            }
        }
    }
}
